import React from 'react';

import classnames from 'classnames/bind';

import styles from './Grouped.module.css';

const cx = classnames.bind(styles);

export default function Grouped({ className, columns, gap, inline, style, ...props }) {
  if (columns) {
    style = {
      ...style,
      gridTemplateColumns: columns,
    };
  }

  if (gap) {
    style = {
      ...style,
      gridGap: gap,
    };
  }

  return <div className={cx('grouped', { inline }, className)} style={style} {...props} />;
}
